export class TenantDetails {
  id: number;
  name: string;
  key?: string;
  logo?: string;
  email?: string;
  phone?: string;
  locale?: string;
  timezone?: string;
  extension?: string;
  address?: string;
  country?: string;
  supportEmail: string;
  pubKey: string;
  subKey: string;
  // sonarignore:start
  is_white_labelled: boolean;
  monochrome_logo: string;
  // sonarignore:end
  constructor(data?: Partial<TenantDetails>) {
    Object.assign(this, data);
  }
}
